import React, { useState } from "react";
import PropTypes from "prop-types";

import { Input, Field, Control, Label, Column } from "rbx";
import moment from "moment";
import {
  BooleanInput,
  DateInput,
  PaymentTermSelect
} from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = { Status: true };

function RouteFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = {
      ...inputs,
      [e.target.name]:
        e.target.name === "CustomerRecIdRef" ||
        e.target.name === "PaymentTermsRecIdRef"
          ? parseInt(value)
          : value
    };

    if (e.target.name === "EndDate_lte") {
      updates.EndDate_gte = moment().format("YYYY-MM-DD");
    }
    setInputs(updates);
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div style={{ width: 700, maxWidth: "100%" }}>
      <Column.Group centered>
        <Column>
          <Field>
            <Control>
              <Label>Route Id</Label>
              <Input
                autocomplete="new"
                name="RouteId_contains"
                type="text"
                value={inputs.RouteId_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Route Description</Label>
              <Input
                autocomplete="new"
                name="RouteDescription_contains"
                type="text"
                value={inputs.RouteDescription_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Status</Label>
              <BooleanInput
                name="Status"
                value={inputs.Status}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>Customer No.</Label>
              <Input
                autocomplete="new"
                name="CustomerNo_contains"
                type="text"
                value={inputs.CustomerNo_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Customer Name</Label>
              <Input
                autocomplete="new"
                name="CustomerName_contains"
                type="text"
                value={inputs.CustomerName_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Contract</Label>
              <Input
                autocomplete="new"
                name="Contract_contains"
                type="text"
                value={inputs.Contract_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <Label>End Date</Label>
              <DateInput
                name="EndDate_lte"
                value={inputs.EndDate_lte}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>Delivery Location Id</Label>
              <Input
                autocomplete="new"
                name="DeliveryLocationID_contains"
                type="text"
                value={inputs.DeliveryLocationID_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
          <Field>
            <PaymentTermSelect
              label="Payment Term"
              name="PaymentTermsRecIdRef"
              value={inputs?.PaymentTermsRecIdRef}
              where={{ Active: true }}
              onChange={handleChange}
            />
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
RouteFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
export default RouteFilters;
